import { FullPageModule } from '../../../styles/global.styles';
import ErrorImage from '../../../assets/images/error.png';
import { ErrorContainer, ErrorMainMessage } from './errorModule.styles';
import { FormattedMessage } from 'react-intl';

// Component to display error messages, with optional custom message
export const ErrorComponent = ({ customMessageId }: { customMessageId?: string }) => {
  return (
    <FullPageModule>
      <ErrorContainer>
        <img src={ErrorImage} style={{ width: '100px', height: '100px' }} />
        <ErrorMainMessage>
          <FormattedMessage id={customMessageId || "error.main"} />
        </ErrorMainMessage>
      </ErrorContainer>
    </FullPageModule>
  );
};
